import AdminOffers from "./AdminOffers";

export default AdminOffers